import { application } from '../application';

import MapController from './map_controller';
application.register('map', MapController);

import ProviderSearchController from './provider_search_controller';
application.register('provider-search', ProviderSearchController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import InquiryFormController from './inquiry_form_controller';
application.register('inquiry-form', InquiryFormController);

import ReviewTextController from './review_text_controller';
application.register('review-text', ReviewTextController);

import PlacesAutocompleteController from './places_autocomplete_controller';
application.register('places-autocomplete', PlacesAutocompleteController);

import DisclousureController from './disclosure_controller';
application.register('disclosure', DisclousureController);

import InfiniteScrollController from './infinite_scroll_controller';
application.register('infinite-scroll', InfiniteScrollController);

import SortToggleController from './sort_toggle_controller';
application.register('sort-toggle', SortToggleController);

import PhotoCarouselController from './photo_carousel_controller';
application.register('photo-carousel', PhotoCarouselController);

import PricingCalculatorController from './pricing_calculator_controller';
application.register('pricing-calculator', PricingCalculatorController);

import MobileFiltersController from "./mobile_filters_controller";
application.register("mobile-filters", MobileFiltersController);

import ExitIntentController from './exit_intent_controller';
application.register("exit-intent", ExitIntentController);

import TypeWriterController from './typewriter_controller';
application.register("typewriter", TypeWriterController);

import SupplyServiceController from "./supply_service_controller";
application.register("supply-service", SupplyServiceController);

import AsyncGoogleImageController from "./async_google_image_controller";
application.register("async-google-image", AsyncGoogleImageController);

import HubSearchController from "./hub_search_controller";
application.register("hub-search", HubSearchController);

// Ph24NewNavbar component is rendered on location pages (pflegeplatz layout)
import Ph24NewNavbarController from "../pages_controllers/ph24_new_navbar_controller";
application.register("ph24-new-navbar", Ph24NewNavbarController);

